import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSettings = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 3.75,
			y: 5.25,
			width: 16.5,
			height: 15,
			rx: 2,
			fill: "url(#paint0_linear_519_31074)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.75 4.75C15.75 4.33579 16.0858 4 16.5 4V4C16.9142 4 17.25 4.33579 17.25 4.75V7C17.25 7.41421 16.9142 7.75 16.5 7.75V7.75C16.0858 7.75 15.75 7.41421 15.75 7V4.75Z",
			fill: "#F8F8FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.75 4.75C6.75 4.33579 7.08579 4 7.5 4V4C7.91421 4 8.25 4.33579 8.25 4.75V7C8.25 7.41421 7.91421 7.75 7.5 7.75V7.75C7.08579 7.75 6.75 7.41421 6.75 7V4.75Z",
			fill: "#F8F8FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6 15.75C6 15.3358 6.33579 15 6.75 15H11.25C11.6642 15 12 15.3358 12 15.75V17.25C12 17.6642 11.6642 18 11.25 18H6.75C6.33579 18 6 17.6642 6 17.25V15.75Z",
			fill: "#F8F8FF"
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_519_31074",
			x1: 4.5,
			y1: 20,
			x2: 18.6565,
			y2: 4.75264,
			gradientUnits: "userSpaceOnUse",
			children: [
				/* @__PURE__ */ _jsx("stop", {
					offset: .09375,
					stopColor: "#2995B8"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .515265,
					stopColor: "#4148DC"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .976683,
					stopColor: "#7F59EB"
				})
			]
		}) })
	]
});
export default SvgSettings;
